import React, { Fragment } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AnnouncementsContainer from "../../components/announcements/AnnouncementsContainer";
import CodingContainer from "../../components/info-containers/CodingContainer";
import RoboticsContainer from "../../components/info-containers/RoboticsContainer";
import TechnologyContainer from "../../components/info-containers/TechnologyContainer";
import VideoContainer from "../../components/video-popup-container/VideoContainer";
import LayoutOne from "../../layouts/LayoutOne";
import BannerFour from "../../wrappers/banner/BannerFour";
import AsSeenInSliderOne from "../../wrappers/brand-logo/AsSeenInSliderOne";
import CoachSlider from "../../wrappers/brand-logo/CoachSlider";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import HeroSliderTen from "../../wrappers/hero-slider/HeroSliderTen";
import TestimonialOne from "../../wrappers/testimonial/TestimonialOne";

const BranchHomePage = () => {
  const location = useLocation();
  const curr_location = useSelector((state) => state.locationsData.location);

  return (
    <Fragment>
      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
        headerTop="visible"
      >
        {/* hero slider */}
        <HeroSliderTen spaceBottomClass="pb-55" />

        {/* Sections */}
        <BannerFour spaceTopClass="pt-15" spaceBottomClass="pb-85" />
        {/* video popup */}
        <VideoContainer bgColorClass="bg-gray-3" />
        {/* Announcements */}
        <AnnouncementsContainer spaceBottomClass="pb-85" />
        {/* fun fact */}
        <FunFactOne
          spaceTopClass="pt-100"
          spaceBottomClass="pb-70"
          bgClass="bg-gray-3"
        />

        <CodingContainer
          spaceBottomClass="pb-20"
          img="/assets/zebra_images/roadmaps/coding_roadmap.png"
        />
        <RoboticsContainer
          spaceBottomClass="pb-20"
          img="/assets/zebra_images/roadmaps/robotics_roadmap.png"
        />
        <TechnologyContainer
          spaceBottomClass="pb-70"
          img="/assets/zebra_images/roadmaps/technology_roadmap.png"
        />
        {/* Benefits */}
        {/* <BannerFive spaceTopClass="pt-15" spaceBottomClass="pb-85" /> */}
        {/* countdown */}
        {/* <PromotionContainer
              spaceTopClass="pt-80"
              spaceBottomClass="pb-70"
              timerImg="/assets/zebra_images/juniors3.jpg"
              dateTime="November 13, 2022 12:12:00"
            />
           
            {/* brand logo slider */}

        <AsSeenInSliderOne spaceBottomClass="pb-35" spaceTopClass="pt-10" />
        <TestimonialOne
          spaceTopClass="pt-95"
          spaceBottomClass="pb-10"
          spaceLeftClass="ml-70"
          spaceRightClass="mr-70"
          bgColorClass="bg-gray-3"
        />
        <CoachSlider spaceBottomClass="pb-35" spaceTopClass="pt-10" />
      </LayoutOne>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    cLocation: state.locationsData.location,
  };
};

export default connect(mapStateToProps)(BranchHomePage);
